<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'admin.backoffice.export.statistics'|translate">
      <div class="row">
        <div class="col-sm-3 col-xl-3">
          <label for="date-format">{{"doctrine.export.information" | translate}}<span class="star">*</span></label>
          <ng-select [(ngModel)]="exportType.entity" name="entity" id="date-format" [items]="entities"></ng-select>
        </div>

        <div class="col-sm-3 col-xl-3">
          <label for="date-from">{{(exportType.entity !=='Orderbook' ? "doctrine.export.from" : "doctrine.export.till") | translate}}</label>
          <div class="input-group mb-0" (clickOutside)="from.close()">
            <input class="form-control "
                   placeholder="yyyy-mm-dd"
                   name="fromdate"
                   id="date-from"
                   [(ngModel)]="exportType.from"
                   ngbDatepicker
                   #from="ngbDatepicker"
            >
            <div class="input-group-append">
              <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                      (click)="from.toggle()" type="button">

              </button>
            </div>
          </div>
        </div>
        <div *ngIf="exportType.entity !=='Orderbook'" class="col-sm-3 col-xl-3">
          <label for="date-to">{{"doctrine.export.to" | translate}}</label>
          <div class="input-group mb-0" (clickOutside)="to.close()">
            <input class="form-control "
                   placeholder="yyyy-mm-dd"
                   name="todate"
                   id="date-to"
                   [(ngModel)]="exportType.to"
                   ngbDatepicker
                   #to="ngbDatepicker"

            >
            <div class="input-group-append">
              <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                      (click)="to.toggle()" type="button">

              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-4" *ngIf="exportType.entity==='Emails'">
          <div class="col-sm-3 col-xl-3">
          </div>

          <div class="col-sm-3 col-xl-3">
              <label for="contact-function">{{"doctrine.user.category" | translate}}<span class="star">*</span></label>
              <ng-select required name="contactFunction" id="contact-function" [items]="contactFunctionItems"
                         [(ngModel)]="selectedContactFunction" [clearable]="false"></ng-select>
          </div>
          <div class="col-sm-3 col-xl-3">
              <label for="dealer-profile">{{"doctrine.invoice_dealer.profile" | translate}}<span class="star">*</span></label>
              <ng-select required name="contactFunction" id="dealer-profile" [items]="dealerProfileItems"
                         [(ngModel)]="selectedDealerProfile" [clearable]="false"></ng-select>
          </div>
      </div>
      <div class="row">
        <div class="col-sm-12 m-t-20">
          <button class="btn btn-primary pull-right" (click)="export()">Generate .xls file</button>
        </div>
      </div>
    </app-card>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
